
export default {
  props: ['info', 'isCheck', 'type'],
  data: () => {
    return {
    };
  },
  computed: {
  },
  created () {
  },
  methods: {
  }
};
